var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDublicateJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 20H3.125C1.40182 20 0 18.5982 0 16.875V6.28906C0 4.56589 1.40182 3.16406 3.125 3.16406H10.5859C12.3091 3.16406 13.7109 4.56589 13.7109 6.28906V16.875C13.7109 18.5982 12.3091 20 10.5859 20ZM3.125 4.72656C2.26349 4.72656 1.5625 5.42755 1.5625 6.28906V16.875C1.5625 17.7365 2.26349 18.4375 3.125 18.4375H10.5859C11.4474 18.4375 12.1484 17.7365 12.1484 16.875V6.28906C12.1484 5.42755 11.4474 4.72656 10.5859 4.72656H3.125ZM16.8359 14.9219V3.125C16.8359 1.40182 15.4341 0 13.7109 0H5.03906C4.60754 0 4.25781 0.349731 4.25781 0.78125C4.25781 1.21277 4.60754 1.5625 5.03906 1.5625H13.7109C14.5724 1.5625 15.2734 2.26349 15.2734 3.125V14.9219C15.2734 15.3534 15.6232 15.7031 16.0547 15.7031C16.4862 15.7031 16.8359 15.3534 16.8359 14.9219Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDublicateJob);
export default __webpack_public_path__ + "static/media/dublicateJob.23c0f846263fc14485e7abd33199d4a0.svg";
export { ForwardRef as ReactComponent };